module.exports = __webpack_public_path__ + "img/ma.07d844d7.svg";